import React from 'react';
import logoSrc from './assets/logo.png';
export const Logo = () => React.createElement("img", {
  src: logoSrc,
  alt: "Phenomenon"
});